import { createStore } from 'vuex'
// import { version } from '@/../package.json'
import appointment from './appointment'
import otbAppointment from './otbAppointment'
import overview from './overview'
import service from './service'
import states from './states'
import station from './station'
import steps from './steps'
import user from './user'
import vehicle from './vehicle'

export const store = createStore({
  modules: {
    user,
    steps,
    states,
    service,
    vehicle,
    station,
    appointment,
    otbAppointment,
    overview,
  },
  state: {
    version: '',
  },
  actions: {
    clearAllState({ commit }) {
      commit('resetUserState', null, { root: true })
      commit('resetStepState', null, { root: true })
      commit('resetStatesState', null, { root: true })
      commit('resetServiceState', null, { root: true })
      commit('resetVehicleState', null, { root: true })
      commit('resetStationState', null, { root: true })
      commit('resetAppointmentState', null, { root: true })
      commit('otbAppointment/resetOtbAppointmentState', null, { root: true })
      commit('resetOverviewState', null, { root: true })
    },
    clearBookingState({ commit }) {
      commit('resetStepState', null, { root: true })
      commit('resetStatesState', null, { root: true })
      commit('resetServiceState', null, { root: true })
      commit('resetVehicleState', null, { root: true })
      commit('resetStationState', null, { root: true })
      commit('resetAppointmentState', null, { root: true })
      commit('otbAppointment/resetOtbAppointmentState', null, { root: true })
      commit('resetOverviewState', null, { root: true })
    },
  },
  // mutations: {
  //   initialiseStore(state) {
  //     if (localStorage.getItem('tvg')) {
  //       let cachedStore = JSON.parse(localStorage.getItem('tvg'))

  //       // remove previous user data
  //       delete cachedStore.user.user
  //       delete cachedStore.user.sessionData

  //       // Check the version stored against current. If different, don't load the cached version
  //       if (cachedStore.version == version) {
  //         // Replace the state object with the stored item (that is merged with state in case of new properties added since last user visit)
  //         this.replaceState(
  //           Object.assign(state, cachedStore)
  //         )
  //       } else {
  //         state.version = version
  //       }
  //     }
  //   }
  // },
})

// // Subscribe to store updates
// store.subscribe((mutation, state) => {
//   // Store the state object as a JSON string
//   localStorage.setItem('tvg', JSON.stringify(state))
// })
